import { ENTITY, USER } from './EditTagsDialog.types';

export const VERBIAGE = {
  [ENTITY]: {
    singular: 'Entity',
    plural: 'Entities',
  },
  [USER]: {
    singular: 'User',
    plural: 'Users',
  },
};
